<template>
	<div>
		<div class="one_01">
			<!-- <div class="one_02" @click="clickBack">
					<i class="el-icon-arrow-left one_03"></i>
					<el-divider direction="vertical"></el-divider>
				</div> -->
			<div class="one_04">
				<el-tabs v-model="activeTabChange" @tab-click="handleTabClick">
					<el-tab-pane v-for="item in tabList" :key="item.key" :label="item.value" :name="item.key">
						<template #label>
							<span v-if="item.isPush" class="isPush">{{ item.value }}</span>
							<span v-else>{{ item.value }}</span>
							<!-- 计数徽标：tabData 中传 { key, value, count } 即可，缺省不显示 -->
							<span v-if="item.count !== undefined && item.count !== null && item.count !== ''" class="tabBadge">
								{{ item.count }}
							</span>
						</template>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div ref="body" class="pd20" :style="bodyHeight === null ? null : { height: bodyHeight + 'px' }">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "TopTab",
	props: {
		activeTab: {
			type: String,
			default: "1"
		},
		tabData: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			bodyHeight: null,
			tabList: [],
			activeTabChange: this.activeTab
		};
	},
	components: {},
	mounted() {
		this.tabList = this.tabData.filter((item) => !item.isHide);
		window.addEventListener("resize", this.scheduleBodyLayout);
		if (typeof ResizeObserver !== "undefined") {
			this.bodyObserver = new ResizeObserver(this.scheduleBodyLayout);
			this.bodyObserver.observe(this.$el);
			if (this.$el.parentElement) this.bodyObserver.observe(this.$el.parentElement);
		}
		this.scheduleBodyLayout();
		// 子组件切换页签或异步显示分页时，父组件不一定触发 updated。
		this.slotObserver = new MutationObserver(this.scheduleBodyLayout);
		this.slotObserver.observe(this.$refs.body, { childList: true, subtree: true });
	},
	activated() { this.scheduleBodyLayout(); },
	updated() { this.scheduleBodyLayout(); },
	beforeDestroy() {
		window.removeEventListener("resize", this.scheduleBodyLayout);
		if (this.bodyObserver) this.bodyObserver.disconnect();
		if (this.slotObserver) this.slotObserver.disconnect();
		cancelAnimationFrame(this.bodyLayoutFrame);
	},
	methods: {
		scheduleBodyLayout() {
			cancelAnimationFrame(this.bodyLayoutFrame);
			this.bodyLayoutFrame = requestAnimationFrame(this.updateBodyHeight);
		},
		updateBodyHeight() {
			const body = this.$refs.body;
			if (!body || !body.getClientRects().length) return;
			this.fitPagedTable(body);
			let bottom = document.documentElement.clientHeight;
			// 路由内容或弹窗可能比浏览器视口更矮，取实际裁切边界。
			for (let parent = this.$el.parentElement; parent; parent = parent.parentElement) {
				if (/^(auto|scroll|hidden|clip)$/.test(getComputedStyle(parent).overflowY)) {
					bottom = Math.min(bottom, parent.getBoundingClientRect().top + parent.clientTop + parent.clientHeight);
				}
			}
			this.bodyHeight = Math.max(0, Math.floor(bottom - body.getBoundingClientRect().top - 12));
		},
		fitPagedTable(body) {
			const visible = el => el.getClientRects().length && !el.closest('.el-dialog__wrapper, .el-drawer__wrapper');
			const tables = Array.from(body.querySelectorAll('.lcsj-table-container')).filter(visible);
			const pagers = Array.from(body.querySelectorAll('.lcsj-pagination')).filter(visible);
			const grids = Array.from(body.querySelectorAll('.el-table')).filter(visible);
			const containers = new Set();
			// 多栏、多个表格及自行计算高度的页面保持各自布局。
			if (tables.length === 1 && grids.length === 1 && pagers.length === 1 && !tables[0].closest('.el-row, .bs-content')) {
				for (let parent = tables[0].parentElement; parent && body.contains(parent); parent = parent.parentElement) {
					containers.add(parent);
					if (parent === body) break;
				}
			}
			for (const el of [body, ...body.querySelectorAll('.pd20--paged-table')]) {
				if (!containers.has(el)) el.classList.remove('pd20--paged-table');
			}
			containers.forEach(el => el.classList.add('pd20--paged-table'));
		},
		// 显示
		showTopTab(data) {
			this.tabList = data.filter((item) => !item.isHide);
		},
		// tab切换
		handleTabClick() {
			// 同时 emit kebab 与 camel 两个事件名，兼容 @tab-change 与 @tabChange
			this.$emit("tab-change", this.activeTabChange);
			this.$emit("tabChange", this.activeTabChange);
		},

		// 点击返回
		clickBack() {
			this.$router.go(-1);
		}
	}
};
</script>

<style scoped>
.one_01 {
	height: 48px;
	background: var(--app-surface);
	display: flex;
	align-items: center;
	padding: 0 16px;
	border: 1px solid var(--app-border);
	border-bottom: none;
	border-radius: var(--app-radius-lg) var(--app-radius-lg) 0 0;
	box-shadow: var(--app-shadow);
}

.one_02 {
	height: 100%;
	display: flex;
	align-items: center;
	cursor: pointer;
}

.one_03 {
	font-size: 18px;
	font-weight: 700;
}

.one_04 {
	height: 100%;
	display: flex;
	align-items: center;
	margin-left: 12px;
	font-size: var(--app-font-sm);
	padding-top: 8px;
	overflow: hidden;
}

.isPush {
	padding: 0px !important;
}

.isPush::before {
	content: "";
	width: 0px;
	height: 15px;
	position: absolute;
	top: 12px;
	left: 0px;
	border-left: 2px solid var(--app-border-strong);
	transform: rotateZ(20deg);
}

/* Tab 计数徽标 */
.tabBadge {
	font-size: var(--app-font-xs);
	background: var(--app-surface-sunken);
	color: var(--app-text-secondary);
	border-radius: 9px;
	padding: 0 6px;
	margin-left: 5px;
	font-weight: 500;
	line-height: 1.6;
}

.one_04 ::v-deep .el-tabs__item.is-active .tabBadge {
	background: var(--app-primary-soft);
	color: var(--app-primary-text);
}

.pd20 {
	background: var(--app-surface);
	border: 1px solid var(--app-border);
	border-top: none;
	border-radius: 0 0 var(--app-radius-lg) var(--app-radius-lg);
	box-shadow: var(--app-shadow);
	display: flex;
	flex-direction: column;
	overflow: auto;
	padding: 0 16px 16px;
	box-sizing: border-box;
	min-height: 0;
	height: auto;
}

/* 筛选和分页占据实际布局空间，只有中间表格滚动；极矮容器允许整体滚动。 */
.pd20 ::v-deep > * { flex-shrink: 0; }
.pd20 ::v-deep > .table-minheight { min-height: 0; }
.pd20 ::v-deep .pd20--paged-table {
	display: flex;
	flex-direction: column;
	flex: 1 1 0;
	min-height: 220px;
	min-width: 0;
	height: auto;
}
.pd20 ::v-deep .pd20--paged-table > * { flex-shrink: 0; }
.pd20--paged-table ::v-deep > .lcsj-table-container {
	flex: 1 1 0;
	min-height: 160px;
	min-width: 0;
}
.pd20 ::v-deep .pd20--paged-table > .lcsj-table-container {
	flex: 1 1 0;
	min-height: 160px;
	min-width: 0;
}
.pd20 ::v-deep > .lcsj-pagination {
	position: static;
	flex-shrink: 0;
}

</style>
